import { getCustomFilters } from '../customFilters.jsx'
import { messages } from "./messages"

export const contactTotals = []

export const contactFields = [
    'name',
    'nameAnalyzed',
    'nameKeyword',
    'email',
    'emailKeyword',
    'organizationName',
    'organizationNameAnalyzed',
    'organizationNameKeyword',
    'nameSort',
    'phoneNumber',
    'address',
    'citySort',
    'cityKeyword',
    'phoneNumberKeywordSearch',
    'note',
    'noteKeyword',
    'noteAnalyzed',
]

export const getContactsFilters = function (context) {
    var newFilters = getCustomFilters(context, "persons")
    var filtersToUse =
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'isArchived',
                label: context.intl.formatMessage(messages["is_archived"]),
                filterMatch: 'isArchived',
                type: 'boolean',
                placeHolder: 'Show archived',
                initialValue: '',
                initialSelect: 'is',
            },
            {
                nameId: 'customerLabelIds',
                label: context.intl.formatMessage(messages["customer_type_placeholder"]),
                filterMatch: 'labelIds',
                type: 'select',
                typeOfSelect: 'label-select',
                multi: false,
                placeHolder: context.intl.formatMessage(messages["customer_type_placeholder"]),
                labelName: 'customerTypeId',
                labelType: 'customer-type',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'customerTagId',
                label: context.intl.formatMessage(messages["customer_tags_placeholder"]),
                filterMatch: 'tagIds',
                type: 'select',
                typeOfSelect: 'label-select',
                multi: false,
                placeHolder: context.intl.formatMessage(messages["customer_tags_placeholder"]),
                labelName: "customerTagId",
                labelType: "customer-tag",
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'updatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'contactId',
                label: context.intl.formatMessage(messages["contact_id"]),
                filterMatch: 'id',
                type: 'select',
                typeOfSelect: 'customer-select',
                initialValue: "",
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl.formatMessage(messages["contact_name"]),
                filterMatch: 'name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'firstName',
                label: context.intl.formatMessage(messages["contact_firstname"]),
                filterMatch: 'firstName',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'lastName',
                label: context.intl.formatMessage(messages["contact_lastname"]),
                filterMatch: 'lastName',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'organizationName',
                label: context.intl.formatMessage(messages["contact_organization_name"]),
                filterMatch: 'organizationNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'phoneNumber',
                label: context.intl.formatMessage(messages["contact_phonenumber"]),
                filterMatch: 'phoneNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'taxNumber',
                label: context.intl.formatMessage(messages["tax_number"]),
                filterMatch: 'taxNumber',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'email',
                label: context.intl.formatMessage(messages["contact_email"]),
                filterMatch: 'emailKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'defaultTax',
                label: context.intl?.formatMessage(messages["default_tax"]),
                filterMatch: 'taxId',
                type: 'select',
                typeOfSelect: 'tax-select',
                multi: true,
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'externalId',
                label: context.intl.formatMessage(messages["external_id"]),
                filterMatch: 'uniqueExternalId',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'recurringStatementEnabled',
                label: context.intl.formatMessage(messages["recurring_statement_enabled"]),
                filterMatch: 'recurringStatementEnabled',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'recurringStatementNextCreationDate',
                label: context.intl.formatMessage(messages["recurring_statement_next_creation_date"]),
                filterMatch: 'recurringStatementNextCreationDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'recurringStatementSendEmail',
                label: context.intl.formatMessage(messages["recurring_statement_send_email_enabled"]),
                filterMatch: 'recurringStatementSendEmail',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'recurringStatementCapturePayment',
                label: context.intl.formatMessage(messages["recurring_statement_capture_payment_enabled"]),
                filterMatch: 'recurringStatementCapturePayment',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'recurringStatementAttachPdf',
                label: context.intl.formatMessage(messages["recurring_statement_attach_pdf_enabled"]),
                filterMatch: 'recurringStatementAttachPdf',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse.concat(newFilters)
}




// WEBPACK FOOTER //
// ./src/common/search-filter/search/contactFilters/contactsFilters.jsx